<!--  -->
<template>
  <div>
    <div class="choosecover chooseitem">
      <div class="text_wei">
        文字内容：
      </div>
      <el-input v-model="linkobj.written" placeholder="请输入展示的文字" />
    </div>
    <div class="choosecover">
      <div class="text_wei">
        链接内容：
      </div>
      <el-input v-model="linkobj.linkwritten" placeholder="链接内容" />
    </div>
    <div class="btn_determine">
      <el-button @click="linkbtn">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      linkobj: {
        written: '',
        linkwritten: ''
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    linkbtn() {
      this.$emit('linkbtn', this.linkobj)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choosecover{
  display: flex;
  align-items: center;
}
.chooseitem{
  margin-bottom: 30px;
}
.text_wei {
  flex-shrink: 0;
}
.btn_determine{
  margin-top: 30px;
  text-align: right;
}
</style>
